/**
 * backgroundCheck.js
 * Samples the outer 25% lateral margins (left and right edges) of the camera frame
 * and computes average color differences between consecutive captures.
 * 
 * If avgDiff < 15, the user has stayed in the exact same spot with the same background.
 */

export function extractEdgeFeatures(videoElement) {
  if (!videoElement) return null;
  const vw = videoElement.videoWidth || videoElement.width;
  const vh = videoElement.videoHeight || videoElement.height;
  if (!vw || !vh) return null;

  try {
    const canvas = document.createElement('canvas');
    canvas.width = 64;
    canvas.height = 36;
    const ctx = canvas.getContext('2d', { willReadFrequently: true });
    if (!ctx) return null;

    ctx.drawImage(videoElement, 0, 0, 64, 36);
    const imgData = ctx.getImageData(0, 0, 64, 36).data;

    // Sample outer lateral margins: Left 25% (cols 0-15) and Right 25% (cols 48-63)
    const features = [];
    for (let y = 0; y < 36; y += 2) {
      for (let x = 0; x < 64; x += 2) {
        if (x < 16 || x >= 48) {
          const idx = (y * 64 + x) * 4;
          features.push(imgData[idx], imgData[idx + 1], imgData[idx + 2]);
        }
      }
    }
    return features;
  } catch (err) {
    return null;
  }
}

export function compareEdgeFeatures(edges1, edges2) {
  if (!edges1 || !edges2 || edges1.length === 0 || edges2.length === 0 || edges1.length !== edges2.length) {
    return 100; // Default to different if no prior comparison exists
  }

  let totalDiff = 0;
  for (let i = 0; i < edges1.length; i++) {
    totalDiff += Math.abs(edges1[i] - edges2[i]);
  }
  return totalDiff / edges1.length;
}

